import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { CacheService } from 'ionic-cache';
import { ApplicationConfig } from '../config';

@Injectable()
export class ServiceProvider {
  public readonly config: any;
  public cache: CacheService;
  constructor() {
    this.config = new ApplicationConfig();
  }

  public createHeader = (): HttpHeaders => {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });
  };

  public createAuthorizationHeader = (token: string): HttpHeaders => {
    return new HttpHeaders({
      Authorization: 'Bearer ' + token,
      Accept: 'application/json'
    });
  };

  public createXFormHeader = (): HttpHeaders => {
    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json'
    });
  };

  public loadToken = (cache: any): Observable<any> => {
    return from(
      cache
        .getItem('access_token')
        .then(token => {
          return token;
        })
        .catch(() => {
          return localStorage.getItem('access_token');
        })
    );
  };

  public loadMaterials = (cache: any): Observable<any> => {
    return from(
      this.cache
        .getItem('materials')
        .then(materials => {
          return materials;
        })
        .catch(() => {
          return localStorage.getItem('materials');
        })
    );
  };

  public loadEndmills = (cache: any): Observable<any> => {
    return from(
      this.cache
        .getItem('endmills')
        .then(endmills => {
          return endmills;
        })
        .catch(() => {
          return localStorage.getItem('endmills');
        })
    );
  };
}
